import HttpService from "./HttpService";
const axios = HttpService.getAxiosClient();
const methods = HttpService.HttpMethods;
const baseURL = process.env.REACT_APP_BACKEND_URL;
const rootRequestMapping = 'sweepDescriptor'

const getDescriptors= async () => {
  try {
    const res = await axios.request({
      url: `${baseURL}${rootRequestMapping}/all`,
      method: methods.GET
    });
    return res.data;
  }
  catch (error) {
    return null;
  }
}

const getDescriptorsByJob= async (id) => {
	if (id==undefined) return null;
	let url=`${baseURL}${rootRequestMapping}/byjob/`+id;
  try {
    const res = await axios.request({
      url: url,
      method: methods.GET
    });
    return res.data;
  }
  catch (error) {
    return null;
  }
}




export { getDescriptors,getDescriptorsByJob  }

